import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Styles/ForgotPassword.css'
import axios from 'axios';
import logo from "../Images/logo1.png";

const ForgotPassword= () => {
  const [email, setEmail] = useState('');
  const [isVerificationSent, setIsVerificationSent] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSendVerificationCode = async (e) => {
    e.preventDefault();

    if (!email || !isValidEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    try {
      const response = await axios.post(
        'https://b2bbackendapi.mmstourism.com/api/b2/agency/sendOTP',
        { email },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200) {
        setIsVerificationSent(true);
        setError('');
        alert('Verification code sent!');
        navigate('/verify-code-admin', { state: { email } }); // assuming /verify-code-admin route exists
      } else {
        setError('Error sending verification code');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to send verification code');
    }
  }; 

  return (
//     <div className="forgot-password-container">
//       <img
//       src={logo}
//       alt="MMS Tourism"
//       className="forgot-logo"
//     />
//       <div className="form-card">
//         <h2>Forgot Password (Agency)</h2>
//         <form onSubmit={handleSendVerificationCode}>
//           {!isVerificationSent && (
//             <>
//               <div className="form-group">
//                 <label>Email:</label>
//                 <input
//                   type="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="Enter your email"
//                   required
//                 />
//               </div>
//               {error && <p className="error-text">{error}</p>}
//               <button type="submit" className="submit-button">Send Verification Code</button>
//             </>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// };
<div className="forgot-password-container">

  {/* ✅ Clickable Logo Above Card */}
  <img
    src={logo}
    alt="MMS Tourism"
    className="forgot-logo-top"
    onClick={() => navigate("/")}   // 👈 back to login page
  />

  <div className="form-card">
    <h2>Forgot Password (Agency)</h2>

    <form onSubmit={handleSendVerificationCode}>
      {!isVerificationSent && (
        <>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          {error && <p className="error-text">{error}</p>}

          <button type="submit" className="submit-button">
            Send Verification Code
          </button>
        </>
      )}
    </form>
  </div>
</div>
    
  );
};
 export default ForgotPassword;
